<template>
<modal-provider name="black-friday-modal" :width="750">
  <div ref="modal" tabindex="0">
    <div class="shum"></div>
    <div class="black-friday__heading-wrap">
      <picture>
        <source :srcset="`/img/black-friday/mario-img.png`" media="(min-width: 650px)" />
        <img class="black-friday__img" :src="`/img/black-friday/mario-img-mob.png`" alt="drill" />
      </picture>

      <img class="black-friday__text-img" src="/img/black-friday/black-friday-metallic.png" alt="black friday">

      <p class="modal__subtitle">
        {{ $t('bf-modal-subtitle') }}
      </p>
    </div>

    <black-friday-form target="modal" @submit="isFormSubmitted = true"></black-friday-form>

  </div>
</modal-provider>
</template>

<script>
import { mapState } from 'vuex'
import cookieHelper from '@/helpers/cookieHelper'

import BlackFridayForm from '@/components/promo-pages/BlackFridayForm'

export default {
  name: 'BlackFridayModal',
  components: {
    BlackFridayForm
  },
  props: {
    delayShowing: {
      type: Number,
      default: 10000
    }
  },
  data () {
    return {
      isFormSubmitted: false
    }
  },
  computed: {
    ...mapState({
      language: state => state.translation.language,
      userFromServer: state => state.user
    }),
    userData () {
      return this.userFromServer?.['user_data']
    },
    isAlreadySubscribed () {
      return !!+this.userData?.subscriber?.['black_friday']
    }
  },
  mounted () {
    const BF_MODAL_COOKIE = 'bf_modal_showed'

    setTimeout(() => {
      if (!cookieHelper.getCookie(BF_MODAL_COOKIE) && !this.isAlreadySubscribed) {
        this.$modal.show('black-friday-modal')
        cookieHelper.setCookie(BF_MODAL_COOKIE, 1)
      }
    }, this.delayShowing)
  }
}
</script>

<style scoped lang="sass">
::v-deep
  .v--modal
    background-color: transparent
    box-shadow: none
    padding: 25px 0

    +mmin($tablet)
      padding: 45px 0

  .modal
    background-color: #0B0C10

  .v--modal-overlay .v--modal-box, .modal
    overflow: visible

  .v--modal-overlay
    padding: 0

  .modal-heading
    padding: 0

.row
  display: flex
  flex-wrap: wrap
  margin-left: -7px
  margin-right: -7px
  .col
    padding: 0 7px
    flex: 0 0 50%
    width: 50%
    &--full
      flex: 0 0 100%
      width: 100%

.modal__subtitle
  position: relative
  color: #e7e7e7
  letter-spacing: 0.05em
  line-height: 1.5
  font-weight: 500
  font-size: 12px
  text-transform: uppercase
  margin: 20px 0 0 0
  max-width: 200px

  +mmin(650)
    max-width: 300px
    font-size: 16px

  +mmin($tablet)
    max-width: 330px

.black-friday__heading-wrap
  margin: 0 0 40px

  +mmin(650)
    margin: 0 0 80px

.black-friday__text-img
  position: relative
  max-width: 390px
  width: 60%
  margin-left: -18px
  margin-top: 20px

  +mmin(450)
    margin-left: -35px

  +mmin($tablet)
    width: 100%

.black-friday__img
  position: absolute
  right: -6px
  top: -5px

  +mmin(650)
    width: auto
    max-width: initial
    right: -10px
    top: -54px

.shum
  position: absolute
  left: 0
  top: 0
  width: 100%
  height: 100%
  background-image: url('/img/black-friday/shum.png')
  background-size: 120px 120px
  background-repeat: repeat
  pointer-events: none
  mix-blend-mode: hue

</style>
